<template>
  <div>
    <h4>Schedule for {{ event.title }}</h4>
    <p>
      Please use the file selector below to select the image file (.png/.jpg) containing the event's schedule.
    </p>

    <b-file name="file" accept="application/pdf, image/png, image/jpeg" v-model="location" placeholder="File" />
    <b-btn class="mt-4" block @click.prevent="onPostMedia">Upload</b-btn>
    <div v-if="event.schedule" class="my-4">
    <b-img :src="event.schedule.contentUrl" fluid alt=""></b-img><br />
    <b-btn variant="link" @click="deleteSchedule()">Delete Schedule</b-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { MEDIA_URL } from '@/config'
const IRI_MEDIA = '/api/media_objects/'
export default {
  data () {
    return {
      eid: null,
      event: {},
      location: []
    }
  },
  computed: {
    ...mapGetters([
      'business',
      'currentUser'
    ])
  },
  methods: {
    ...mapActions([
      'getEvent',
      'putEvent',
      'postMedia',
      'deleteMedia'
    ]),
    checkFile () {
      if (!this.location.name) {
        alert('please select a file')
        return false
      }
      return true
    },
    async onPostMedia (/* evt */) {
      if (!this.checkFile()) return
      let mediaResp = await this.postMedia({
        user: this.currentUser.id,
        slug: this.business.uriName + '/standings',
        business: this.business.id,
        file: this.location
      })
      this.putEvent({
        id: this.eid,
        schedule: IRI_MEDIA + mediaResp.id
      }).then(resp => {
        this.event = resp
      })
    },
    deleteSchedule () {
      this.$bvModal.msgBoxConfirm('Delete Schedule?')
      .then(confirm => {
        if (confirm) {
          let medid = this.event.schedule.id
          this.putEvent({
            id: this.eid,
            schedule: null
          }).then(resp => {
            this.event = resp
            this.deleteMedia(medid)
          })
        }
      })
    },
    doGetEvent () {
      this.eid = this.$route.params.eid
      if (this.eid) {
        this.getEvent({
          id: this.eid
        }).then(resp => {
          this.event = resp
          // update schedule media url
          if (this.event.schedule) {
            this.event.schedule.contentUrl = MEDIA_URL + this.event.schedule.contentUrl
          }
        })
      }
    }
  },
  created () {
    this.doGetEvent()
    this.generateSchedule()
  }
}
</script>